
				var addMethods = require("../../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["runChatTrimmer","countTokensForText","countTokensForMessages"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "833a3910621ea11b5d15.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "833a3910621ea11b5d15.worker.js");
					addMethods(w, methods)
					
					return w
				}
			